import UserModel from '@/models/User';

const GET_USER_INFO = 'GET_USER_INFO';
const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

/**
 * 获取个人信息详细数据
 */
async function getUserInfo() {
  const payload = await new UserModel().userInfo();
  return {
    type: GET_USER_INFO,
    payload
  }
}

/**
 * 修改个人信息详细数据
 */
async function updateUserInfo(params) {
  const payload = await new UserModel().updateUserInfo(params);
  return {
    type: UPDATE_USER_INFO,
    payload
  }
}

const ACTION_TYPES = {
  GET_USER_INFO,
  UPDATE_USER_INFO,
};

const ACTION = {
  getUserInfo,
  updateUserInfo,
};

const UserInfo = {
  ACTION_TYPES,
  ACTION
}

export default UserInfo;